import React from 'react';
import { Table, TableHead, TableHeadRow, TableHeadCell, TableBody, TableRow, TableCell } from './table';
import { gouden_stier } from '../lib/historicalData';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import { H6 } from './text';

export default function GoudenStierTable() {
	return (
		<>
			{Object.keys(gouden_stier).map((seasonKey) => (
				<Disclosure key={seasonKey}>
					{({ open }) => (
						<>
							<Disclosure.Button className="flex w-full justify-between px-4 py-4 text-left text-black-500 hover:cursor-pointer">
								<H6>{seasonKey.replace('_', ' ').toUpperCase()}</H6>
								<ChevronUpIcon
									className={`${
										open ? 'rotate-180 transform transition-all' : ' transition-all'
									} h-6 w-6 text-black-500`}
								/>
							</Disclosure.Button>
							<Disclosure.Panel>
								<div className="overflow-x-auto">
									<Table className="table-auto overflow-scroll w-full">
										<TableHead className="bg-white">
											<TableHeadRow>
												<TableHeadCell>Seizoen</TableHeadCell>
												<TableHeadCell>Categorie</TableHeadCell>
												<TableHeadCell>Naam</TableHeadCell>
												<TableHeadCell>Club</TableHeadCell>
											</TableHeadRow>
										</TableHead>
										<TableBody className="bg-white divide-y divide-gray-200">
											{gouden_stier[seasonKey as keyof typeof gouden_stier].map((row, i) => (
												<TableRow key={i} striped>
													<TableCell>{row.Seizoen}</TableCell>
													<TableCell>{row.Categorie}</TableCell>
													<TableCell>{row.Naam}</TableCell>
													<TableCell>{row.Club}</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</div>
							</Disclosure.Panel>
						</>
					)}
				</Disclosure>
			))}
		</>
	);
}
